const compareDates = (startDate, endDate) => {
    var parts = startDate.split("/");
    var startDateValue = Number(parts[2] + parts[1] + parts[0]);

    parts = endDate.split("/");
    var endDateValue = Number(parts[2] + parts[1] + parts[0]);

    return startDateValue <= endDateValue;
};

const filterByDate = (transactions, startDate, endDate) => 
{
   startDate = new Date(startDate).toLocaleDateString("en-GB");
   endDate = new Date(endDate).toLocaleDateString("en-GB");

   return transactions.filter((transaction) => (compareDates(startDate, transaction.date) && compareDates(transaction.date, endDate)))
}

const filterByName = (transactions, name) => 
{
    return transactions.filter((transaction) => transaction.serviceName.toLowerCase().startsWith(name))
}

export const filter = (transactions, name) => {
  
    if(name !== '')
    {
        return filterByName(transactions, name)
    }
    else 
    {
        return transactions
    }
}